import React from 'react';
import clsx from 'clsx';

const sizeClasses = {
  hero: 'landing-shot--hero',
  feature: 'landing-shot--feature',
  thumb: 'landing-shot--thumb',
};

const MarketShot = ({ src, alt, size = 'feature', className = '' }) => (
  <img
    src={src}
    alt={alt}
    width={1320}
    height={2868}
    className={clsx('landing-shot', sizeClasses[size], className)}
    loading="lazy"
  />
);

export default MarketShot;
